module.exports = __webpack_public_path__ + "static/0078-dc66e78f57539a0f99c3d0bfb3082361.png";